import axiosInstance from '../../../config/axiosInstance';
const  JobCostService = {
    async GetAllJobCost(redirectCallback,IssueID) {
        try {            
           const ClientID=localStorage.getItem('CompanyID');
           const response = await axiosInstance.get(`/Job/GetAllJobCost?IssueID=${IssueID}`);
           return response.data;
        } catch (error) {           
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteJobCost(ID,redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Job/DeleteIssueCost?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
};

export default JobCostService;